/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ab_Err_Name_RequiredInputs */

const es_ab_err_name_required = /** @type {(inputs: Ab_Err_Name_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El nombre del barco es obligatorio`)
};

const gl_ab_err_name_required = /** @type {(inputs: Ab_Err_Name_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O nome do barco é obrigatorio`)
};

const en_ab_err_name_required = /** @type {(inputs: Ab_Err_Name_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Boat name is required`)
};

/**
* | output |
* | --- |
* | "Boat name is required" |
*
* @param {Ab_Err_Name_RequiredInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const ab_err_name_required = /** @type {((inputs?: Ab_Err_Name_RequiredInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ab_Err_Name_RequiredInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_ab_err_name_required(inputs)
	if (locale === "en") return en_ab_err_name_required(inputs)
	return es_ab_err_name_required(inputs)
});